var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgCargoShip(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 22.987,
    height: 14.928,
    viewBox: "0 0 22.987 14.928",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "cargo-ship-1056_1_",
    "data-name": "cargo-ship-1056 (1)",
    transform: "translate(83.036 106.851)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Groupe_625",
    "data-name": "Groupe 625",
    transform: "translate(-83.036 -106.851)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_515",
    "data-name": "Trac\\xE9 515",
    d: "M17.374,177.007a17.061,17.061,0,0,1-6.083-1.225,13.607,13.607,0,0,0-10.774,0,.379.379,0,0,1-.277-.705,14.323,14.323,0,0,1,11.334,0c4.068,1.555,7.728,1.56,10.865.009a.379.379,0,0,1,.336.679A12.041,12.041,0,0,1,17.374,177.007Z",
    transform: "translate(0 -162.079)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_516",
    "data-name": "Trac\\xE9 516",
    d: "M22.44,54.669a11.056,11.056,0,0,1-2.242.818l2.733-4.494a.379.379,0,0,0-.324-.576H19.892V44.564a.379.379,0,0,0-.379-.379H8.09a.379.379,0,0,0-.379.379v6.894H7.073l-.356-.748V45.954a.379.379,0,0,0-.379-.379H2.722a.379.379,0,0,0-.369.292L1.279,50.416H.418a.379.379,0,0,0-.378.4,8.32,8.32,0,0,0,.814,3.612c-.2.072-.407.146-.612.226a.379.379,0,0,0,.277.705,13.606,13.606,0,0,1,10.774,0,17.061,17.061,0,0,0,6.083,1.225,12.684,12.684,0,0,0,2.04-.164h0a.375.375,0,0,0,.109-.018,11.834,11.834,0,0,0,3.252-1.058.379.379,0,0,0-.336-.679Zm-3.763-4.252a.378.378,0,0,0-.307.157l-.637.884H14.18V49.791h4.954v.624h-.456ZM8.469,47.368h4.953v1.666H8.469Zm10.665,1.666H14.18V47.368h4.954Zm0-2.424H14.18V44.943h4.954ZM8.469,44.943h4.953V46.61H8.469Zm0,4.848h4.953v1.666H8.469ZM3.022,46.333H5.96v4.083h-3.9Zm8.554,8.326A14.043,14.043,0,0,0,1.6,54.183a6.428,6.428,0,0,1-.774-3.009H6.1L6.492,52a.379.379,0,0,0,.342.216H17.927a.378.378,0,0,0,.307-.157l.637-.884h3.063l-2.746,4.515A14.941,14.941,0,0,1,11.575,54.66Z",
    transform: "translate(0 -44.185)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_517",
    "data-name": "Trac\\xE9 517",
    d: "M41.732,75.738H40.618a.379.379,0,0,1,0-.758h1.114a.379.379,0,0,1,0,.758Z",
    transform: "translate(-36.57 -72.172)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_518",
    "data-name": "Trac\\xE9 518",
    d: "M184.227,141.4h-.861a.379.379,0,0,1,0-.758h.861a.379.379,0,0,1,0,.758Z",
    transform: "translate(-166.3 -131.846)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_519",
    "data-name": "Trac\\xE9 519",
    d: "M156.525,141.4h-.861a.379.379,0,0,1,0-.758h.861a.379.379,0,0,1,0,.758Z",
    transform: "translate(-141.124 -131.846)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_520",
    "data-name": "Trac\\xE9 520",
    d: "M128.825,141.4h-.861a.379.379,0,0,1,0-.758h.861a.379.379,0,1,1,0,.758Z",
    transform: "translate(-115.95 -131.846)"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCargoShip);
export default __webpack_public_path__ + "static/media/cargo-ship.8256ae03aec4b2f2f192f484039a94ab.svg";
export { ForwardRef as ReactComponent };